export const styles = {
  snackBar: {
    '& .MuiPaper-root': {
      position: 'relative',
      padding: '12px 12px',
    },
    '& .MuiSnackbarContent-message': {
      padding: '0px',
    },
    '& .MuiSnackbarContent-action': {
      // position: 'relative',
      // top: '0px',
      // right: '0px',
      marginBottom: 'auto',
      padding: '0px 0px 0px 4px',
      marginTop: '-6px',
    },
  },
  container: {
    gap: '12px',
  },
  notification: {
    flexDirection: 'row',
    gap: '12px',
    maxWidth: '352px',
  },
  title: {
    color: '#787878',
    fontSize: '12px',
    fontWeight: '400',
  },
  message: {
    fontSize: '14px',
    fontWeight: '400',
  },
  navigateButton: {
    marginLeft: 'auto',
    padding: '2px 8px',
    fontSize: '14px',
    fontWeight: '500',
    marginRight: '-26px',
  },
}
